import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import {SubHeading} from "@answersnow/pkg-theme";

export const LoadingTable = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "80vh",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <CircularProgress size={30} color="primary" style={{ margin: 10 }} />
      <SubHeading>Loading</SubHeading>
    </div>
  );
};
